import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {feedFetch, hashFeedFetch, topicTrendingListFetch, feedFiltersFetch} from '../../actions/index';
import {mobileCheck} from '../../helpers';
import { getUrlParameter } from '@tickled-media/web-components.tm-helpers';
import cx from '../../styles';
import { translate } from 'react-i18next';
// import style from './style.css';
import BaseLayout from '../../components/Layout/BaseLayout';
import FeedContainer from '../Feed';
import FeedSwitcherComponent from '../../components/Layout/Sidebars/FeedSwitcher';
import FeedSwitcherMobile from '../../components/Layout/Sidebars/FeedSwitcher/Mobile';
// import TopicTrendingListSidebar from '../../components/Layout/Sidebars/TopicList';
// import { adCoreInit } from '../../components/Ads/Bootstrap';
import AdPlaceholder from '../../components/Ads/Placeholder';
import AdCoreSlot from '../../components/Ads/AdCoreSlot';
import Breadcrumbs from '../../components/Layout/Breadcrumbs';

class PageContainer extends Component {

    constructor(props) {
        super(props);
        // this.dfpArr = [];

        const filterValue = {
            '/feed/latest': 'home_feed',
            '/feed/popular': 'home_feed',
            '/feed/poll': 'poll',
            '/feed': 'home_feed'
        };

        const subfilterValue = {
            '/feed/latest': 'latest',
            '/feed/popular': 'popular',
            '/feed/poll': 'poll',
            '/feed': 'newsfeed'
        }

        this.state = {
            filter: getUrlParameter('type') || filterValue[props.match && props.match.url ? props.match.url : props.landingUrl] || 'hash', 
            subfilter: subfilterValue[props.match && props.match.url ? props.match.url : props.landingUrl], 
            rightSidebar: [], 
            filterId: getUrlParameter('id') || 0
        };
        //ads
        /*if(typeof window != 'undefined') {
            let ads = this.props.configReducer.ads;
            if(props.appReducer.deviceType == 'desktop') {
                this.dfpArr = [
                    {networkId: ads.networkId, unit: ads.common.half_page.unit, id: ads.common.half_page.id, size: [ads.common.half_page.w, ads.common.half_page.h], collapse: true}
                ];
            } else {
                // this.dfpArr = [
                //     {networkId: ads.networkId, unit: ads.mobile.top.unit, id: ads.mobile.top.id, size: [ads.mobile.top.w, ads.mobile.top.h], collapse: true}
                // ];
            }        
            adCoreInit(this.dfpArr);
        }*/
    }

    componentDidMount() {
        //set current filter
        if(this.props.match.params.type){
            this.setState({
                subfilter: this.props.match.params.type
            });
        }
        //other async requests
        if(!mobileCheck() && !this.props.appReducer.topicsTrendingSidebar.length){
            this.props.topicTrendingListFetch();
        }
        //sidebars
        this.buildRightSidebar();
        //to prevent dynamic feed
        if(this.props.feedReducer.accessedFrom === this.props.location.pathname && this.props.feedReducer.currentFeed === this.props.match.params.type) return false;
        //needed because filled feeds are allowed to switch and cant check on empty
        if((!this.props.feedReducer.ifServerFilled || this.props.feedReducer.accessedFrom === '/' || this.props.feedReducer.currentFeed !== this.props.match.params.type) && this.props.match.path != '/feed/hash/:slug'){
            const filter = this.props.match.params.type === 'poll' ? null : this.state.filter;
            const filterId = this.props.match.params.type === 'poll' ? null : this.state.filterId;
            this.props.feedFetch(this.props.match.params.type, 1, true, this.props.location.pathname, filter, filterId);
            if(this.props.userReducer.id){
                this.props.feedFiltersFetch()
            }
            //scroll fix
            window.scrollTo(0,0);
        } 

        if(this.props.match.path === '/feed/hash/:slug'){
            this.setState({filter: 'hash', subfilter: 'hash', filterId: 0});
            this.props.hashFeedFetch(this.props.match.params.slug, 1, true, this.props.location.pathname);
        }    
    }

    componentDidUpdate(prevProps) {
        if((prevProps.location.pathname !== this.props.location.pathname) && this.props.match.path !== '/feed/hash/:slug') {
            //scroll fix
            window.scrollTo(0,0);
            const filter = this.props.match.params.type === 'poll' ? null : this.state.filter;
            const filterId = this.props.match.params.type === 'poll' ? null : this.state.filterId;
            this.props.feedFetch(this.props.match.params.type, 1, true, this.props.location.pathname, filter, filterId);            
        }

        if((prevProps.location.pathname !== this.props.location.pathname) && this.props.match.path === '/feed/hash/:slug'){
            this.props.hashFeedFetch(this.props.match.params.slug, 1, true, this.props.location.pathname);
        }  
    }

    switchFeed = (filter, subfilter, path, filterId) => {
        this.setState({filter, subfilter, filterId});
        this.redirect(path, filter, filterId);
    }

    redirect = (pathname, filter, filterId, state=null) => {
        this.props.history.replace({
            pathname,
            search: ['poll','hash'].indexOf(filter) === -1 ? `?type=${filter}&id=${filterId}&lng=${this.props.appReducer.locale}` : '',
            ...(state && {state})
        });
    }

    buildAdSlots = () => {
        const ads = this.props.configReducer.ads;
        return [
            ads.networkId &&
            <div className={cx("shadow-card")}>
                <AdCoreSlot networkId={ads.networkId} 
                    adUnit={ads.common.half_page.unit}
                    styleClass={ads.common.half_page.styleClass}
                    size={[ads.common.half_page.w, ads.common.half_page.h]}
                    id={ads.common.half_page.id}/>
            </div>
        ];  
    }

    buildLeftSidebar = () => {
        /*let trendingListSidebarComponent =
            <div className={cx("shadow-card", !this.props.appReducer.topicsTrendingSidebar.length && 'hide')}>
                <TopicTrendingListSidebar topics={this.props.appReducer.topicsTrendingSidebar} />
            </div>;*/

        const lc = [
            <FeedSwitcherComponent trendingTopicsElems={this.props.appReducer.topicsTrendingSidebar} appReducer={this.props.appReducer} />
        ];

        return lc;
    }

    buildRightSidebar = () => {
        /*let appDownloadCreative =
            <div className={cx("shadow-card")}>
                <a href="https://community.theasianparent.com/app/download?utm_source=community-static-banner&utm_medium=web&utm_campaign=app-download">
                    <img src={this.props.configReducer['region'].staticAd1} alt="TAPApps_launch" loading="lazy"/>
                </a>
            </div>*/

        const adSlots = this.buildAdSlots();
        const rightSidebar = this.props.appReducer.deviceType === 'desktop' ? adSlots : [];
        this.setState({rightSidebar});
    }

    render(){
        // const siteUrl = this.props.configReducer.siteUrl;
        const {t, history, match, landingUrl, serverReqCookie, appReducer, location, feedReducer, userReducer} = this.props;
        const labelName = match.params.type ? (match.params.type.charAt(0).toUpperCase() + match.params.type.slice(1)) : 'HashFeed';

        return (
            <BaseLayout history={history}
                match={match} 
                landingUrl={landingUrl}
                serverReqCookie={serverReqCookie}
                leftCards={this.buildLeftSidebar()}
                rightCards={this.state.rightSidebar.length ? this.state.rightSidebar : [<div className={cx("shadow-card")}><AdPlaceholder w="320" h="250"/></div>]} 
            >

                <FeedSwitcherMobile
                    currentFilter={this.state.filter}
                    currentSubFilter={this.state.subfilter}
                    currentFilterId={this.state.filterId}
                    onClickHandler={this.switchFeed}
                    filtersList={feedReducer.filtersList}
                    appReducer={appReducer}
                    userReducer={userReducer}
                    match={match}
                    t={t}
                />

                <FeedContainer {...this.props} />

                <Breadcrumbs links={[
                    {location: '/feed', label: 'Home'},
                    {location: location.pathname, label: labelName},
                ]} />
                
            </BaseLayout>
        );
    }
}

//map state
const mapStateToProps = (state) => state;

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        feedFetch,
        feedFiltersFetch,
        hashFeedFetch,
        topicTrendingListFetch
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(PageContainer));
